import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';

import { RootState } from '../../../store';
import { BanksListState, BankState } from '../../../store/actions/bank';
import NoData from '../../error/nodata';
import BankCard from '../card';

const BanksList = () => {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const bankState: BanksListState = useSelector((state: RootState) => state.banksPaginated);

    return (
        <Grid container flexWrap={'wrap'} alignContent={'space-between'}>
            {bankState?.list?.page?.content.map((currentBank: BankState) => {
                return <BankCard key={currentBank?.id} bankInfo={currentBank} userTimeZone={userTimeZone} />;
            })}
            {bankState?.list?.page?.content?.length === 0 && <NoData />}
        </Grid>
    );
};

export default BanksList;
